export interface FrontendEnvironment {
  apiBaseUrl: string;
  apiTimeoutMs: number;
  authRequired: boolean;
  buildCommit: string;
  demoLabel: string;
}

function readBoolean(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined || value.trim() === "") return fallback;
  if (value === "1" || value.toLowerCase() === "true") return true;
  if (value === "0" || value.toLowerCase() === "false") return false;
  throw new Error("VITE_MBIP_LOGIN_REQUIRED must be true/false or 1/0.");
}

function readPositiveInteger(value: string | undefined, fallback: number): number {
  if (value === undefined || value.trim() === "") {
    return fallback;
  }

  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed <= 0) {
    throw new Error("VITE_MBIP_API_TIMEOUT_MS must be a positive integer.");
  }
  return parsed;
}

function readApiBaseUrl(value: string | undefined): string {
  const candidate = value?.trim() || "/mbip-api";
  if (candidate.startsWith("/") && !candidate.startsWith("//")) {
    return candidate.replace(/\/$/, "");
  }
  const url = new URL(candidate);
  if (url.protocol !== "http:" && url.protocol !== "https:") {
    throw new Error(
      "VITE_MBIP_API_BASE_URL must be a root-relative path or use http/https.",
    );
  }
  return url.toString().replace(/\/$/, "");
}

export const frontendEnvironment: Readonly<FrontendEnvironment> = Object.freeze({
  apiBaseUrl: readApiBaseUrl(import.meta.env.VITE_MBIP_API_BASE_URL),
  apiTimeoutMs: readPositiveInteger(
    import.meta.env.VITE_MBIP_API_TIMEOUT_MS,
    10_000,
  ),
  authRequired: readBoolean(import.meta.env.VITE_MBIP_LOGIN_REQUIRED, false),
  buildCommit: import.meta.env.VITE_MBIP_BUILD_COMMIT?.trim() || "UNDECLARED",
  demoLabel: import.meta.env.VITE_MBIP_DEMO_LABEL?.trim() || "",
});
